import { createContext } from 'react';

import { MainLayoutContextType } from './types';

export const MainLayoutContext = createContext<MainLayoutContextType | null>(null);
